<template>
  <unicom-linha class="arquivo-justificativa" :espacamento="false">
    <unicom-coluna sm="auto" style="padding-right: 12px">
      <IconeNormal class="icone" />
    </unicom-coluna>
    <unicom-coluna
      sm="auto"
      alinhamento="center"
      style="height: 100%; padding-bottom: 2px"
    >
      <unicom-linha :espacamento="false" style="height: 100%">
        <unicom-coluna sm="12">
          <div>
            <span class="negrito" style="padding-right: 12px">
              {{ objetoArquivo.nomeArquivo }}
            </span>
            <span class="segunda-cor-fonte">
              {{ objetoArquivo.tamanhoArquivo }}
            </span>
          </div>
        </unicom-coluna>
        <unicom-coluna sm="12" alinhamento="end">
          <div>
            {{ objetoArquivo.mensagemStatus }} - {{ objetoArquivo.dataEnvio }}
          </div>
        </unicom-coluna>
      </unicom-linha>
    </unicom-coluna>
    <unicom-coluna sm="auto" class="ml-auto" alinhamento="center">
      <unicom-icone
        class="icone-acao"
        :class="{ desativado: !objetoArquivo.baixavel }"
        v-if="!mostrarDownload"
        tooltipNome="Baixar"
        nome="download"
        @click.native="$emit('baixar-arquivo')"
        :tamanho="20"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import { EnumPerfis } from "../../../../../../../../shared/helpers/Enum";
import IconeNormal from "../Icones/IconeNormal";

export default {
  components: {
    IconeNormal
  },
  computed: {
    mostrarDownload() {
      console.log(this.papelUsuarioMixin.chave);
      return (
        this.papelUsuarioMixin.chave === EnumPerfis.UB_CONSULTA ||
        this.papelUsuarioMixin.chave === EnumPerfis.ADM_RECURS_PROPRIO
      );
    }
  },
  props: {
    objetoArquivo: {
      type: Object,
      default: () => {
        return {
          nomeArquivo: "",
          tamanhoArquivo: 0,
          dataEnvio: "",
          mostrarIconeExcluir: true,
          mensagemStatus: "",
          baixavel: true
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./Arquivo.scss";
</style>
